export const siteInfo = {
  name: '国产在线观看',
  tagline: '高清国产视频免费在线观看平台',
  description: '国产在线观看首选平台，海量高清国产视频免费畅享，无需下载即可在线观看最新国产影视剧、综艺、短片，支持手机电脑多端流畅播放，每日更新内容，给你最极致的国产视频在线观看体验。',
  url: 'https://guochanzaixianguankan.com',
  foundedYear: 2020,
  email: 'contact@guochanzaixianguankan.com',
  phone: '400-888-9999',
  address: '北京市朝阳区建国路88号国贸大厦A座',
  socialLinks: {
    weibo: 'https://weibo.com/guochanzaixian',
    wechat: 'guochanzaixian',
    douyin: 'guochanzaixian',
  },
  stats: {
    totalVideos: '50,000+',
    dailyUsers: '1000万+',
    monthlyActive: '5000万+',
    totalViews: '100亿+',
  },
};

export const faqs = [
  {
    question: '国产在线观看是否需要注册？',
    answer: '国产在线观看平台无需注册即可免费观看所有视频内容，我们致力于为用户提供最便捷的在线观看体验。注册账号后可以享受收藏、历史记录、个性化推荐等更多功能。',
  },
  {
    question: '视频画质怎么样？支持高清播放吗？',
    answer: '我们平台所有视频均支持高清画质播放，大部分内容提供1080P甚至4K超清画质选项。您可以根据自己的网络状况和设备性能自主选择合适的清晰度，确保流畅的观看体验。',
  },
  {
    question: '支持哪些设备观看？',
    answer: '国产在线观看平台全面支持PC电脑、平板电脑、智能手机等多种设备的在线观看。您只需使用浏览器访问我们的网站即可，无需下载任何插件或APP，随时随地畅享精彩内容。',
  },
  {
    question: '视频更新频率如何？',
    answer: '我们团队每日更新最新内容，确保您能够第一时间观看到最新的国产影视剧、综艺节目和短视频。热门剧集和综艺节目通常在上线后1-2小时内即可在我们的平台上观看。',
  },
  {
    question: '观看视频需要付费吗？',
    answer: '国产在线观看平台始终坚持免费原则，所有视频内容均可免费在线观看，无需支付任何费用。我们通过广告收入维持平台运营，致力于为国产影视爱好者提供一个优质的免费观影平台。',
  },
  {
    question: '如果在观看过程中遇到问题怎么办？',
    answer: '如果您在观看过程中遇到卡顿、无法播放或其他技术问题，可以通过网页底部的联系方式与我们取得联系。我们的技术支持团队将在24小时内为您解决问题，确保您能够顺畅地享受观影体验。',
  },
];

export const brandValues = [
  {
    title: '内容为本',
    description: '我们始终坚持内容质量第一的原则，精心筛选每一部上线的视频作品，确保为用户提供最优质的国产影视内容。',
    icon: 'ri-star-line',
  },
  {
    title: '用户体验',
    description: '从页面设计到播放体验，我们不断优化每一个细节，致力于打造最流畅、最舒适的在线观看平台。',
    icon: 'ri-user-heart-line',
  },
  {
    title: '技术驱动',
    description: '采用先进的视频编码和CDN加速技术，确保全国各地的用户都能享受到稳定、流畅的高清播放体验。',
    icon: 'ri-cpu-line',
  },
  {
    title: '版权尊重',
    description: '我们严格遵守国家版权法律法规，所有上线内容均经过合法授权，为国产影视行业健康发展贡献力量。',
    icon: 'ri-shield-check-line',
  },
];